if (!customElements.get('ja-product-details')) {
  customElements.define('ja-product-details', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-tab-panel]')];
      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.querySelector('[data-tab-list]').setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panels[index].id);
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        this.panels[index].tabIndex = 0;
        tab.addEventListener('click', event => {
          event.preventDefault();
          this.select(index);
        }, options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (event.key === ' ') next = index;
          if (next === undefined) return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        }, options);
      });
      this.querySelectorAll('.ja-pdp-software__price-link').forEach(link => {
        link.addEventListener('click', event => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const target = document.getElementById(link.hash.slice(1));
          if (!target || !this.contains(target)) return;
          event.preventDefault();
          if (window.location.hash !== link.hash) {
            window.history.pushState(window.history.state, '', link.hash);
          }
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
            block: 'start'
          });
        }, options);
      });
      this.classList.add('ja-pdp-details--enhanced');
      const defaultIndex = this.tabs.findIndex(tab => tab.hasAttribute('data-default-tab'));
      this.select(defaultIndex === -1 ? 0 : defaultIndex);
      this.revealHash();
      window.addEventListener('hashchange', () => this.revealHash(), options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if (index !== -1) this.select(index);
      }, options);
    }
    select(index) {
      this.tabs.forEach((tab, current) => {
        const selected = current === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (!selected && !this.panels[current].hidden && this.panels[current].querySelector('video, iframe')) {
          window.pauseAllMedia();
        }
        this.panels[current].hidden = !selected;
      });
    }
    revealHash() {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
      const target = document.getElementById(id);
      if (!target) return;
      const index = this.panels.findIndex(panel => panel === target || panel.contains(target));
      if (index !== -1) this.select(index);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }
  });
}
